import React from 'react';
import styled from '@emotion/styled';
import { UserMenuConsumer } from '../context/UserMenuContext';

const CloseIcon = styled.svg<{ active: boolean }>`
  width: 1rem;
  height: 1rem;
  display: ${p => (p.active ? 'inline-block' : 'none')};
  color: ${p => (p.active ? '#ffffff' : '#4694ce')};
`;

const MenuClose = () => {
  return (
    <UserMenuConsumer>
      {({ state }) => (
        <CloseIcon data-testid="menu-close-close-icon" active={state.active} viewBox="0 0 20 20">
          <path d="M20 2.73L17.27 0 10 7.27 2.73 0 0 2.73 7.27 10 0 17.27 2.73 20 10 12.73 17.27 20 20 17.27 12.73 10z" />
        </CloseIcon>
      )}
    </UserMenuConsumer>
  );
};

export { MenuClose, MenuClose as default };
